module.exports = __webpack_public_path__ + "static/media/3@2x.c4798e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_148/img/3@2x.png
// module id = 1424
// module chunks = 0